import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

interface AnimatedButtonProps {
  to: string;
  text: string;
  className?: string;
}

const AnimatedButton = ({ to, text, className = '' }: AnimatedButtonProps) => {
  const buttonVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    },
    hover: { 
      scale: 1.05,
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)"
    }
  };

  return (
    <motion.div
      variants={buttonVariants}
      whileHover="hover"
      className="inline-block"
    >
      <Link 
        to={to} 
        className={`inline-flex items-center px-8 py-3 bg-gradient-to-r from-blue-600 
          to-purple-600 text-white rounded-lg font-semibold group ${className}`}
      >
        {text}
        <svg 
          className="w-5 h-5 ml-2 transform transition-transform group-hover:translate-x-1" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M13 7l5 5m0 0l-5 5m5-5H6" 
          />
        </svg>
      </Link>
    </motion.div>
  );
};

export default AnimatedButton;